import claimScoreApiServiceClient from '../client';
import {
  CreateCaseRolePayload,
  CreateCaseRoleResponse,
  DeleteCaseRolePayload,
  DeleteCaseRoleResponse,
  DeleteOrganizationRolePayload,
  DeleteOrganizationRoleResponse,
  UpdateCaseRolePayload,
  UpdateCaseRoleResponse,
  UpdateOrganizationRolePayload,
  UpdateOrganizationRoleResponse,
  UserPermissionsAllOrganizationsResponse,
  UserPermissionsByOrganizationResponse,
} from './types';

export const getUserPermissionsAllOrganizations =
  async (): Promise<UserPermissionsAllOrganizationsResponse> => {
    const { data } = await claimScoreApiServiceClient.get(`/permissions`);

    return data;
  };

export const getUserPermissionsByOrganization = async (
  organizationId: string,
): Promise<UserPermissionsByOrganizationResponse> => {
  const { data } = await claimScoreApiServiceClient.get(
    `/permissions/organizations/${organizationId}`,
  );

  return data;
};

export const updateOrganizationRole = async ({
  organizationId,
  targetUsers,
}: UpdateOrganizationRolePayload): Promise<UpdateOrganizationRoleResponse> => {
  const { data } = await claimScoreApiServiceClient.put(
    `/permissions/organizations/${organizationId}`,
    {
      targetUsers,
    },
  );

  return data;
};

export const deleteOrganizationRole = async ({
  organizationId,
  targetUsers,
}: DeleteOrganizationRolePayload): Promise<DeleteOrganizationRoleResponse> => {
  const { data } = await claimScoreApiServiceClient.delete(
    `/permissions/organizations/${organizationId}`,
    {
      params: {
        targetUsers,
      },
    },
  );

  return data;
};

export const updateRoleByCase = async ({
  caseId,
  targetUsers,
}: UpdateCaseRolePayload): Promise<UpdateCaseRoleResponse> => {
  const { data } = await claimScoreApiServiceClient.put(
    `/permissions/cases/${caseId}`,
    {
      targetUsers,
    },
  );

  return data;
};

export const deleteRoleByCase = async ({
  caseId,
  targetUsers,
}: DeleteCaseRolePayload): Promise<DeleteCaseRoleResponse> => {
  const { data } = await claimScoreApiServiceClient.delete(
    `/permissions/cases/${caseId}`,
    {
      params: {
        targetUsers,
      },
    },
  );

  return data;
};

export const createRoleByCase = async ({
  caseId,
  targetUsers,
}: CreateCaseRolePayload): Promise<CreateCaseRoleResponse> => {
  const { data } = await claimScoreApiServiceClient.post(
    `/permissions/cases/${caseId}`,
    {
      targetUsers,
    },
  );

  return data;
};
